"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledComponentsModifiers = require("styled-components-modifiers");

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _types = require("../../../providers/NotificationsProvider/types");

var _focusRingWithColor = _interopRequireDefault(require("../../../utils/focusRingWithColor"));

var _skyPlane = _interopRequireDefault(require("../../../utils/skyPlane"));

var _useTranslations = _interopRequireDefault(require("../../../utils/useTranslations"));

var _Button = _interopRequireDefault(require("../../Button"));

var _Grid = _interopRequireDefault(require("../../Grid"));

var _Notification = _interopRequireDefault(require("../Notification"));

var _useNotifications2 = _interopRequireDefault(require("../useNotifications"));

var _constants = require("../constants");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NotificationsContainer = _styledComponents.default.div.withConfig({
  displayName: "NotificationsPanel__NotificationsContainer",
  componentId: "sc-1u8dp2k-0"
})(["max-height:", ";margin-bottom:", ";margin-top:", ";overflow-y:hidden;padding-bottom:", ";position:fixed;right:", ";top:0;min-width:calc(1.25rem + ", ");z-index:", ";overflow-x:hidden;scrollbar-width:thin;", ";", ";"], function (_ref) {
  var _ref$marginTop = _ref.marginTop,
      marginTop = _ref$marginTop === void 0 ? 0 : _ref$marginTop;
  return "calc(100vh - ".concat((0, _rem.default)(_spacing.default.base * marginTop), ");");
}, function (_ref2) {
  var _ref2$marginTop = _ref2.marginTop,
      marginTop = _ref2$marginTop === void 0 ? 0 : _ref2$marginTop;
  return (0, _rem.default)(_spacing.default.base * marginTop);
}, function (_ref3) {
  var _ref3$marginTop = _ref3.marginTop,
      marginTop = _ref3$marginTop === void 0 ? 0 : _ref3$marginTop;
  return (0, _rem.default)(_spacing.default.base * marginTop);
}, (0, _rem.default)(_spacing.default.base * 0.8), (0, _rem.default)(_spacing.default.base), _constants.NOTIFICATION_CARD_WIDTH, function (_ref4) {
  var _ref4$zIndex = _ref4.zIndex,
      zIndex = _ref4$zIndex === void 0 ? 100 : _ref4$zIndex;
  return zIndex;
}, function (_ref5) {
  var scroll = _ref5.scroll,
      _ref5$notifications = _ref5.notifications,
      notifications = _ref5$notifications === void 0 ? [] : _ref5$notifications;
  return scroll && notifications.length > 2 ? "overflow-y: auto;" : "overflow-y: hidden;";
}, function (_ref6) {
  var notifications = _ref6.notifications;
  return (0, _isEmpty.default)(notifications) && "width : 0";
});

var FloatingButton = (0, _styledComponents.default)(_Button.default).attrs({
  variant: 'inverted'
}).withConfig({
  displayName: "NotificationsPanel__FloatingButton",
  componentId: "sc-1u8dp2k-1"
})(["box-shadow:", ";&:focus,&:focus:not(:active){border-color:", ";", ";}&:hover,&:hover:not(:active){background-color:", ";color:", ";}"], (0, _skyPlane.default)(2), (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _focusRingWithColor.default)((0, _toColorString.default)(_color.default.interaction.pacificOcean40)), (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _toColorString.default)(_color.default.interaction.pacificOcean.fg));

var FloatingButtonColumn = _styledComponents.default.div.withConfig({
  displayName: "NotificationsPanel__FloatingButtonColumn",
  componentId: "sc-1u8dp2k-2"
})(["display:flex;flex:1;height:24px;justify-content:flex-end;padding-left:", ";padding-right:", ";"], (0, _rem.default)(_spacing.default.base), (0, _rem.default)(_spacing.default.base));

var NotificationContainer = _styledComponents.default.div.withConfig({
  displayName: "NotificationsPanel__NotificationContainer",
  componentId: "sc-1u8dp2k-3"
})(["height:auto;max-height:0;opacity:0;transition:opacity 1s cubic-bezier(0.33,1,0.68,1),max-height 1s cubic-bezier(0.33,1,0.68,1);", ";"], (0, _styledComponentsModifiers.applyStyleModifiers)(_defineProperty({}, _types.NotificationState.DISPLAYING, function () {
  return (0, _styledComponents.css)(["max-height:100vh;opacity:1;"]);
}), 'renderState'));

function NotificationsPanel(_ref7) {
  var marginTop = _ref7.marginTop,
      zIndex = _ref7.zIndex;

  var _useNotifications = (0, _useNotifications2.default)(),
      dismissAll = _useNotifications.dismissAll,
      isDismissingAll = _useNotifications.isDismissingAll,
      notifications = _useNotifications.notifications;

  var translate = (0, _useTranslations.default)();
  return (0, _isEmpty.default)(notifications) ? null : _react.default.createElement(NotificationsContainer, {
    scroll: !isDismissingAll,
    marginTop: marginTop,
    zIndex: zIndex,
    notifications: notifications
  }, _react.default.createElement(_Grid.default.Container, null, _react.default.createElement(_Grid.default.Row, {
    alignment: "end"
  }, _react.default.createElement(FloatingButtonColumn, null, !isDismissingAll && notifications.length >= 2 && _react.default.createElement(FloatingButton, {
    onClick: dismissAll,
    size: "small",
    text: translate(undefined, 'notifications.dismissAll')
  })))), _react.default.createElement(_Grid.default.Container, null, (notifications || []).map(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 3),
        notificationProps = _ref9[0],
        body = _ref9[1],
        _ref9$ = _ref9[2],
        notificationID = _ref9$.notificationID,
        state = _ref9$.state;

    return _react.default.createElement(_Grid.default.Row, {
      key: notificationID,
      marginTop: 0.2
    }, _react.default.createElement(_Grid.default.Column, null, _react.default.createElement(NotificationContainer, {
      renderState: state
    }, _react.default.createElement(_Notification.default, notificationProps, body))));
  })));
}

var _default = NotificationsPanel;
exports.default = _default;